// extracted by mini-css-extract-plugin
export default {"container":"styles_container__vbVDk","hello":"styles_hello__C7hab"};